import { useState } from "react";
import { withRouter } from "react-router-dom";

import '../assets/css/partnerPortal/appDeveloper.scss';
import ButtonOne from "./ButtonOne";
import ButtonArrow from "./ButtonArrow";


function TitleSubTitleCenter(props) {

    const [title] = useState(props.title);
    const [sectionWidth] = useState(props.sectionWidth);
    const [subTitle] = useState(props.subTitle);
    const [eyeBrownHeader] = useState(props.eyeBrownHeader);
    const [addClass] = useState(props.addClass);
    const [hasButtons] = useState(props.hasButtons);
    const [buttonOneName] = useState(props.buttonOneName);
    const [buttonOneLink] = useState(props.buttonOneLink);
    const [buttonOneWidth] = useState(props.buttonOneWidth);
    const [buttonOnepadding] = useState(props.buttonOnepadding);
    const [buttonSecondName] = useState(props.buttonSecondName);
    const [buttonSecondLink] = useState(props.buttonSecondLink);
    const [buttonSecondWidth] = useState(props.buttonSecondWidth);


    return (

        <>
        <div className={(sectionWidth ? sectionWidth + " mb-4 " : "width66 mb-4 ")  + addClass}>
        {eyeBrownHeader ?<div className="eyebrowHeader">
                        {eyeBrownHeader}
            </div> : ""}
            <div className="introframeHeader">
                {title}
            </div>
            <div className="introframeSubText">
                {subTitle}
            </div>
            {hasButtons ? <div className="d-flex align-items-center justify-content-center align-self-stretch">
                <ButtonOne text={buttonOneName} link={buttonOneLink} withoutIcon={true} classNameOfA={buttonOneWidth + " increaseWidthButton"} className={buttonOnepadding + " mr-5"} />
                {/* <ButtonArrow buttonName={buttonSecondName} link={buttonSecondLink} /> */}
                <ButtonOne text={buttonSecondName} link={buttonSecondLink} withoutIcon={true} classNameOfA={buttonSecondWidth} className={buttonOnepadding} />
            </div> : ""}
        </div>
        </>

    )


}

export default withRouter(TitleSubTitleCenter);



